import * as React from 'react';
import { Component } from '../../Utils';

const prettyFileIcons = require('pretty-file-icons');

const importAll = (r) => {
    let modules = {};
    r.keys().map((item) => { modules[item.replace('./', '')] = r(item); });
    return modules;
}

const images = importAll(require.context('pretty-file-icons/svg/', false, /\.(png|jpe?g|svg)$/));


export interface IFileProps {
    value?: string;
    id: string;
    onChange: (id:string, e: React.ChangeEvent<HTMLInputElement>) => void,
    url: string;
    disabled?:boolean;
    isLoader: boolean;
    schema?: any
}

interface IState {
    error?: string;
}

interface FileIconProps {
    value: string;
    url:string;
}

class FileIcon extends React.Component<FileIconProps>{
    render() {
        const { value } = this.props;

        let extension = (value.toLowerCase().endsWith('.docx') && ' .doc') || (!value.toLowerCase().endsWith('.docx') && value);
        
        const fileIconPath = prettyFileIcons.getIcon(extension);
        const fileIcon = images[fileIconPath + '.svg'];

        return (
            <span className="input-group--file" style={{width:"1%", flex:"1 0 auto"}}>
                <div className="form-control form-control--file">
                    <label className="file-load">
                        <a download href={this.props.url} target="__blank">
                            <span className="row valign">
                                <img className="fileicon" src={fileIcon} alt={value} />
                                <span className="control-label control-label--file" title={value}>{value}</span>
                            </span>
                        </a>
                    </label>
                </div>
            </span> 
        )
    }
}

export class File extends Component<IFileProps, IState> {
    private file: HTMLInputElement;

    constructor() {
        super();
        this.state = {
            error: null
        }
    }
    public render() {
        return this.props.value === null || this.props.isLoader ?
                (
                    <div className="form-control">
                        {
                            !this.props.isLoader ? (
                                <label className="file-load">
                                    <input disabled={this.props.disabled} ref={file => this.file = file} className="file-load__input"
                                        type="file"
                                        onChange={(e) => this.props.onChange(this.props.id, e) } />
                                    <button type="button" className="file-load__button">Выбрать файлы</button>
                                </label>
                            ): [
                                <span key={1} className="fa fa-spinner fa-2x fa-spin"></span>,
                                <span key={2} className="control-label control-label--file">Файл сохраняется...</span>
                            ]
                        }
                    </div>
                ) : (<FileIcon url={this.props.url} value={this.props.value} />);
    }
}




// WEBPACK FOOTER //
// ./src/components/controls/standart/File.tsx